import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['articlesContainer', 'articleCount'];
  static values = { 
    deleteUrl: String
  };

  connect() {
    this.updateArticleNumbers();
    
    document.addEventListener('turbo:before-stream-render', (event) => {
      setTimeout(() => {
        this.updateArticleNumbers();
        this.scrollToLast();
      }, 100);
    });
  }

  async deleteArticle(articleId) {
    if (!this.hasDeleteUrlValue) return false;
    
    try {
      const url = this.deleteUrlValue.replace('ARTICLE_ID', articleId);
      const response = await fetch(url, {
        method: 'DELETE',
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content,
          'Accept': 'text/vnd.turbo-stream.html'
        }
      });
      
      return response.ok;
    } catch (error) {
      console.error('Error deleting article:', error);
      return false;
    }
  }

  showError(message) {
    const toast = document.createElement('div');
    toast.className = 'alert alert-danger position-fixed';
    toast.style.cssText = 'bottom: 20px; right: 20px; z-index: 9999; padding: 10px 20px;';
    toast.innerHTML = `<i class="fas fa-exclamation-circle mr-2"></i>${message}`;
    document.body.appendChild(toast);
    
    setTimeout(() => toast.remove(), 4000);
  }

  scrollToLast() {
    const lastArticle = this.articlesContainerTarget.lastElementChild;
    if (lastArticle) {
      lastArticle.scrollIntoView({ behavior: 'smooth', block: 'center' });
      this.flash(lastArticle);
    }
  }

  toggleArticle(event) {
    event.preventDefault();
    const article = event.target.closest('.newsletter-article');
    const content = article.querySelector('.article-content');
    const icon = event.target.closest('.toggle-article')?.querySelector('i');
    
    content.classList.toggle('d-none');
    icon?.classList.toggle('fa-chevron-up');
    icon?.classList.toggle('fa-chevron-down');
  }

  expandAll(event) {
    event.preventDefault();
    this.articlesContainerTarget.querySelectorAll('.article-content').forEach(c => c.classList.remove('d-none'));
    this.articlesContainerTarget.querySelectorAll('.toggle-article i').forEach(i => {
      i.classList.remove('fa-chevron-down');
      i.classList.add('fa-chevron-up');
    });
  }

  collapseAll(event) {
    event.preventDefault();
    this.articlesContainerTarget.querySelectorAll('.article-content').forEach(c => c.classList.add('d-none'));
    this.articlesContainerTarget.querySelectorAll('.toggle-article i').forEach(i => {
      i.classList.remove('fa-chevron-up');
      i.classList.add('fa-chevron-down');
    });
  }

  updateArticleNumbers() {
    const articles = this.articlesContainerTarget.querySelectorAll('.newsletter-article:not(.marked-for-removal)');
    
    articles.forEach((article, index) => {
      const numberEl = article.querySelector('.article-number');
      if (numberEl) numberEl.textContent = index + 1;
      
      const positionInput = article.querySelector('input[name*="[position]"]');
      if (positionInput) positionInput.value = index;
    });

    document.querySelectorAll('[data-newsletter-editor-target="articleCount"]').forEach(el => {
      el.textContent = articles.length;
    });
  }

  updateTitlePreview(event) {
    const article = event.target.closest('.newsletter-article');
    const titlePreview = article?.querySelector('.article-title-preview');
    
    if (titlePreview) {
      const newTitle = event.target.value.trim();
      titlePreview.textContent = newTitle || 'Nieuw artikel';
      titlePreview.classList.toggle('text-muted', !newTitle);
      titlePreview.classList.toggle('font-italic', !newTitle);
    }
  }

  previewImage(event) {
    const file = event.target.files[0];
    if (!file) return;

    const article = event.target.closest('.newsletter-article');
    const previewContainer = article?.querySelector('.image-preview');
    const uploadPlaceholder = article?.querySelector('.upload-placeholder');
    const currentImage = article?.querySelector('.current-image');
    
    if (previewContainer) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const img = previewContainer.querySelector('img');
        if (img) {
          img.src = e.target.result;
          previewContainer.classList.remove('d-none');
          uploadPlaceholder?.classList.add('d-none');
          currentImage?.classList.add('d-none');
        }
      };
      reader.readAsDataURL(file);
    }
  }

  async markForRemoval(event) {
    event.preventDefault();
    const article = event.target.closest('.newsletter-article');
    const articleId = article.dataset.articleId;
    
    if (!articleId) return;
    
    if (!confirm('Weet je zeker dat je dit artikel wilt verwijderen?')) return;
    
    article.style.opacity = '0.5';
    
    const deleted = await this.deleteArticle(articleId);
    if (deleted) {
      article.remove();
      this.updateArticleNumbers();
    } else {
      article.style.opacity = '1';
      alert('Er ging iets mis bij het verwijderen');
    }
  }

  removeNewArticle(event) {
    event.preventDefault();
    const article = event.target.closest('.newsletter-article');
    
    if (confirm('Weet je zeker dat je dit artikel wilt verwijderen?')) {
      article.remove();
      this.updateArticleNumbers();
    }
  }

  flash(element) {
    element.style.backgroundColor = '#e8f4ff';
    setTimeout(() => element.style.backgroundColor = '', 500);
  }
}
